import { withInstall } from '@/utils'
import UserSelect from './src/userSelect.vue'
export default withInstall(UserSelect)
